import { ActionTree, GetterTree, MutationTree, Module } from 'vuex';
import { RootState } from '../interfaces/rootState';
import { CredentialType } from '@/store/interfaces/commpix-api/credentialType';
import credentialType from '@/store/types/credentialType';
import { httpCommpix } from '@/util/HTTPCommpix';

const namespaced = true;

const initialState = (): CredentialType[] => {
  return [];
};

const state: CredentialType[] = initialState();

const mutations: MutationTree<CredentialType[]> = {
  [credentialType.mutations.SET_CREDENTIAL_TYPES_LIST](state, credentialTypes: CredentialType[]) {
    state.splice(0, state.length, ...credentialTypes);
  },
};

const actions: ActionTree<CredentialType[], RootState> = {
  async [credentialType.actions.CREDENTIAL_TYPES_LIST]({ commit, }) {
    const response = await httpCommpix.get('/credential-types');
    commit(credentialType.mutations.SET_CREDENTIAL_TYPES_LIST, response.data);
  },
};

const getters: GetterTree<CredentialType[], RootState> = {
  [credentialType.getters.GET_CREDENTIAL_TYPES_LIST]: (state): CredentialType[] => {
    return state;
  },
};

export const credentialTypeModule: Module<CredentialType[], RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};

export default credentialTypeModule;
